export default __webpack_public_path__ + "static/media/s8.1542c9e7.jpg";